import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OMCheckboxDropdown from '../../../components/OMComponents/OMCheckboxDropdown/OMCheckboxDropdown';

export default class MultiselectWrapper extends Component {
  handleChange = (currValue) => {
    const { value: values, onChange } = this.props;
    const value = values.map(item => (typeof item === 'number') ? item.toString() : item);
    const currVal = (typeof currValue === 'number') ? currValue.toString() : currValue;
    const index = value.indexOf(currVal);

    if (currVal === 'all') {
      return onChange(['all']);
    }
    if (value[0] === 'all') {
      onChange([currVal]);
    } else {
      if (index !== -1) {
        value.splice(index, 1);
      } else {
        value.push(currVal);
      }
      if (!value.length || value.length === this.props.options.length - 1) {
        onChange(['all']);
      } else {
        onChange(value);
      }
    }
    return true;
  };

  render() {
    return (
      <OMCheckboxDropdown
        optionValueIsString={this.props.optionValueIsString}
        options={this.props.options || []}
        title={this.props.title}
        onChange={this.handleChange}
        value={this.props.value || []}
        className={this.props.multiSelectClassName}
        onOpen={this.props.onOpen}
        width={this.props.width}
        titleContainerClassName={this.props.titleContainerClassName}
      />
    );
  }
}

MultiselectWrapper.propTypes = {
  options: PropTypes.array,
  title: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  onChange: PropTypes.func,
  onOpen: PropTypes.func,
  multiSelectClassName: PropTypes.string,
  width: PropTypes.number,
  optionValueIsString: PropTypes.bool,
  titleContainerClassName: PropTypes.string
};
